import React, { useMemo } from "react";

import { EditButton } from "ra-friendsofbabba";
import EyeIcon from "@material-ui/icons/Visibility";
import { get } from "lodash";
import { useGetIdentity } from "react-admin";
import { useRoles } from "ra-friendsofbabba";

const EditOrViewButton = ({ ...props }) => {
  const roles = useRoles();
  const { identity } = useGetIdentity();
  const additionalProps = useMemo(
    () =>
      identity?.user_id === get(props.record, "user_id") ||
      roles.some((r) => ["admin", "president"].indexOf(r.code) !== -1)
        ? null
        : {
            label: "ra.action.view",
            icon: <EyeIcon />,
          },
    [roles, identity, props.record]
  );
  return <EditButton {...props} {...additionalProps} />;
};

export default EditOrViewButton;
